/**
 * @module Stage
 * @return {Object} public methods.
 */
const Stage = (function () {
    var $stageSlider;
    var $sliderItems = null;
    var $stageOverlay;
    var full;

    function init() {
        $sliderItems = $('.stage-slider .stage-slider__item');

        if ($sliderItems.length === 0) return false;

        $stageOverlay = $('.stage__overlay');

        setStageImagesSize();

        // prevent chrome from scrolling to focused element on stage
        $('.stage .slick-track > a').bind('focusin focus', function(e) {
            e.preventDefault();
            // set free focus on focus
            $(e.target).blur();
            return false;
        });

        window.addEventListener('resize', onWindowResize, false);
    }

    function onWindowResize() {
        setStageImagesSize();
    }

    /**
     * Set stage slider images size (height).
     */
    function setStageImagesSize() {
        full = false;

        if (matchMedia('only screen and (min-width: 742px)').matches) {
            full = true;
        }

        if (matchMedia('only screen and (min-width: 940px)').matches) {
            $sliderItems.css('height', $stageOverlay.outerHeight() + 80 + 400);
        } else {
            $sliderItems.css('height', 400);
        }

        if (full) {
            $sliderItems.each(function(index, value){
                var $stageItem = $(value);
                var imageFull = $stageItem.data('image-full');

                if (imageFull !== undefined) {
                    $stageItem.css('background-image', 'url(' + imageFull + ')');
                }
            });
        }

        $sliderItems.show();
    }

    // Return public methods
    return {
        init: init
    };
})();

window.Stage = Stage;
export default Stage;
